import React from 'react';
import { useTranslation } from '../../i18n';
import './style.scss';

const SiteAnnouncement = () => {
  const { t } = useTranslation();
  const message = t('announcement');

  return (
    <div className="site-announcement" role="status" aria-label={message}>
      <div className="site-announcement__track">
        <span>{message}</span>
        <span aria-hidden="true">{message}</span>
      </div>
    </div>
  );
};

export default SiteAnnouncement;
